import { Button, Grid, Paper, Typography, Stack } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import HAppRoutes from '../../../app/features/routes/helpers/HAppRoutes';
import { useTranslation } from 'react-i18next';
import langAuthLogin from '../features/login/langs/langAuthLogin';
import AuthLogin from '../features/login/AuthLogin';
import { useAuthContext } from '../contexts/AuthContext';
import AuthRoutes from '../AuthRoutes';

const PAuthLogin = () => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const auth = useAuthContext();
	return (
		<Grid container spacing={3} alignItems="center" justifyContent="center">
			<Grid item md={7} className="flex items-center">
				<Paper variant="elevation" style={{ padding: '36px', textAlign: 'center' }}>
					<Typography
						variant="h1"
						component="h1"
						style={{ fontWeight: 600, fontSize: '1.5rem', marginBottom: '24px' }}
					>
						{t(langAuthLogin.title.tag)}
					</Typography>
					<AuthLogin />
				</Paper>
				<Stack spacing={3} style={{ textAlign: 'center', marginTop: '20px' }}>
					{auth.authContext === 'investor' ? (
						<>
							<Button
								variant="text"
								sx={{ color: 'white', fontWeight: 400, textDecorationLine: 'underline' }}
								size="small"
								onClick={() => navigate(HAppRoutes.getPath(AuthRoutes.password_forgot.tag))}
							>
								{t(langAuthLogin.forget_password.tag)}
							</Button>
							{/* <CAppDialog
											maxWidth="sm"
											open={openDialogPasswordForgot}
											onClose={() => setOpenDialogPasswordForgot(false)}
										>
											<Typography
												variant="h1"
												component="h1"
												style={{
													textAlign: 'center',
													fontWeight: 600,
													fontSize: '1.5rem',
													marginBottom: '24px',
												}}
											>
												{t(langAuthPasswordForgot.title_reinit_password.tag)}
											</Typography>
											<FAuthPasswordForgot />
										</CAppDialog> */}
						</>
					) : (
						''
					)}

					{/* <StyledDialog
                    open={openDialogPasswordForget}
                    // leftContent={<img alt="..." className=" img-fit-container" src={svgImage1} />}
                    onClose={() => setOpenDialogPasswordForget(false)}
                    contentSize={12}
                    maxWidth="sm"
                    title="Mot de passe oublié"
                    description={
                        <Typography className="italic mb-24">
                            Veuillez saisir votre adresse e-mail pour recevoir le lien qui vous permettra de créer un
                            nouveau mot de passe.
                        </Typography>
                    }
                >
                    <UserPasswordForgetForm email={null} onSend={email => handleSendPasswordForgetEmail(email)} />
                </StyledDialog> */}
				</Stack>
			</Grid>
		</Grid>
	);
};

export default PAuthLogin;
